const PROGRAM_STATUS_COLORS = {
  active: 'bg-green-100 text-green-700',
  coming_soon: 'bg-yellow-100 text-yellow-700',
  default: 'bg-gray-100 text-gray-700',
};

const CATEGORY_BADGE_COLORS = {
  'Fundraisers': 'bg-amber-100 text-amber-800',
  'Health Initiatives': 'bg-emerald-100 text-emerald-800',
  'Community Support': 'bg-blue-100 text-blue-800',
  default: 'bg-blue-100 text-blue-800',
};

const RSVP_TYPE_COLORS = {
  vip: 'bg-purple-100 text-purple-700',
  donation: 'bg-amber-100 text-amber-700',
  default: 'bg-gray-100 text-gray-600',
};

const PAYMENT_STATUS_COLORS = {
  paid: 'bg-green-100 text-green-700',
  free: 'bg-blue-100 text-blue-700',
  default: 'bg-yellow-100 text-yellow-700',
};

const RSVP_STATUS_COLORS = {
  confirmed: 'bg-green-100 text-green-700',
  default: 'bg-yellow-100 text-yellow-700',
};

const VOLUNTEER_STATUS_COLORS = {
  new: 'bg-blue-100 text-blue-700',
  contacted: 'bg-yellow-100 text-yellow-700',
  active: 'bg-green-100 text-green-700',
  default: 'bg-gray-100 text-gray-500',
};

const CHECKIN_COLORS = {
  true: 'bg-green-100 text-green-700',
  false: 'bg-gray-100 text-gray-500',
};

export const getProgramStatusColor = (status) => PROGRAM_STATUS_COLORS[status] || PROGRAM_STATUS_COLORS.default;
export const getCategoryBadgeColor = (category) => CATEGORY_BADGE_COLORS[category] || CATEGORY_BADGE_COLORS.default;
export const getRsvpTypeColor = (type) => RSVP_TYPE_COLORS[type] || RSVP_TYPE_COLORS.default;
export const getPaymentStatusColor = (status) => PAYMENT_STATUS_COLORS[status] || PAYMENT_STATUS_COLORS.default;
export const getRsvpStatusColor = (status) => RSVP_STATUS_COLORS[status] || RSVP_STATUS_COLORS.default;
export const getVolunteerStatusColor = (status) => VOLUNTEER_STATUS_COLORS[status] || VOLUNTEER_STATUS_COLORS.default;
export const getCheckinColor = (checkedIn) => checkedIn ? CHECKIN_COLORS.true : CHECKIN_COLORS.false;
